import React from "react";
import { Navigate } from "react-router-dom";

import { useGetMeQuery } from "redux/services/apiService";
import { selectUserPermissions } from "redux/slices/user";
import { useAppSelector } from "redux/store";

type MatchMode = "any" | "all";

type Props = {
  permissions: string[];
  match?: MatchMode;
};

const PrivatePermission: React.FC<Props> = ({
  children,
  permissions,
  match = "any",
}): JSX.Element => {
  const userPermissions = useAppSelector(selectUserPermissions);
  const { isLoading } = useGetMeQuery();

  if (isLoading) {
    return null;
  }

  const hasAccess =
    match === "all"
      ? permissions.every((permission) => userPermissions.includes(permission))
      : permissions.some((permission) => userPermissions.includes(permission));

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivatePermission;
